import { BusMapData } from "../types/app.types";

export const calculateAvailableSeats = (
  totalSeats: number,
  maxOccupancy: number
): number => {
  return totalSeats - maxOccupancy;
};

export const getAgentColor = (
  busMapData: BusMapData | null,
  agent: string
): string => {
  if (!busMapData) return "#e9ecef";

  const sampleSeat = busMapData.seatList.find(
    (seat) => seat.isOccupied && seat.passenger?.seller === agent
  );

  return sampleSeat?.passenger?.agentColor || "#e9ecef";
};

export const getAgentSeatCount = (
  busMapData: BusMapData | null,
  agent: string
): number => {
  if (!busMapData) return 0;

  return busMapData.seatList.filter(
    (seat) => seat.isOccupied && seat.passenger?.seller === agent
  ).length;
};

export const getAgentRevenue = (
  busMapData: BusMapData | null,
  agent: string
): number => {
  if (!busMapData?.statistics.agentRevenues) return 0;
  return busMapData.statistics.agentRevenues[agent] || 0;
};
